// 英文文件


module.exports = {
    // 主页
    home: {
        bannerFloting: "You can compare platforms in all directions at your fingertips, helping you choose the most efficient and fastest logistics route.",
        nowSing: 'Register now for free',
        tab:['Quick quote', 'Track goods', 'Local storage','Japanese purchasing agency'],
        queryShipment: {
            company: 'Courier company',
            number: 'Tracking number ',
            tips: '* Enter up to 25 groups of tracking numbers, one in a row',
            placeholder: 'Please enter the tracking number'
        },
        help: 'Need help with a problem?',
        localStorage: {
            reserve: {
                title: 'Reservation',
                description: 'Simple online or by phone, we will send storage boxes to the house for free',
            },
            tidy: {
                title: 'Clean up',
                description: 'Put your personal belongings in the storage box and set a personal security code to lock it'
            },
            store: {
                title: 'Storage',
                description: 'When you are ready, please contact us and arrange to pick up your storage box and store it properly'
            },
            extract: {
                title: 'Extract',
                description: 'As long as necessary, as long as you retrieve the storage box you need through the online account management arrangement, we will send the storage box back to your home'
            }
        },
        JapanesePurchasingAgencyage: {
            reserve: {
                title: 'Fill in the product link',
                description: 'Fill in the link of the web page where the purchasing agent is located, shopping budget and other information',
            },
            tidy: {
                title: 'Optional additional fee service',
                description: 'Whether additional fee-based services are required'
            },
            store: {
                title: 'Preferential exchange rate and other offers',
                description: 'Do you need preferential exchange rates and other discounts'
            },
            extract: {
                title: 'WhatsAPP detailed talk',
                description: 'Jump to WhatsApp and discuss details with customer service'
            }

        },
        whyChoice: {
            title: '為何選擇Goods 2 Go？',
            oneBlock: {
                title: '跨境電商貨運配送',
                text: '我們知道優質的電子商貿物流服務對你的B2C業務(商家對顧客)至為重要。 「好運」致力為你提供最實惠和方便快捷的跨境物流方案，包括香港進口、出口、空運、 電商倉儲配送服務。'
            },
            twoBlock: {
                title: '標準快遞服務',
                text: '需要門對門標準快遞服務？只要登入「好運」系統，質優價廉的快遞服務便在你手中。你只需按步驟下單和列印運送標籤，而相關文件、上門收件和派送服務系統都為你安排妥當，在三個工作天內整個快遞服務便能輕鬆完成。'
            },
            threeBlock: {
                title: '全方位比較平台',
                text: '如何尋找最便宜而又切合你需要的快遞服務，同時又不用多花時間？「好運」的搜尋比較功能給你兩全其美的方案。你只需輸入基本資料如寄件地及收件區的地址、聯絡人、貨品的類別尺寸和重量，各大快遞公司的運費報價馬上一目了然，選擇心水快遞服務就是這麼簡單。省時省力省錢就從你選用「好運」開始！'
            },
            fourBlock: {
                title: '倉儲服務',
                text: '我們深明優質的物流服務也要良好的倉儲服務配合。「好運」樂意為你提供專業的倉儲、訂單流程管理、貨物存取、包裝、物流配送等一站式服務，讓你的管理得心應手。'
            }
        }
    },
    // 头部
    header: {
        mail: 'Ship now',
        hello: 'hello',
        login: 'login',
        logout: "logout",
        cancel: "Are you sure to log out of your account?"
    },
    // 起点终点选择
    shipmentStarEnd: {
        start: "Delivery place",
        end: 'please choose',
        startPlacehodler: 'Delivery place',
        endPlacehodler: 'Please select the shipping destination first'
    }
}
